<template>
    <small class="payyo-websocket-status">
        <i :class="iconClass"></i>
        {{ l(langKey) }}
    </small>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('payment', ['payyoWebSocketConnected']),

        iconClass() {
            if (this.payyoWebSocketConnected === true) {
                return 'fa-solid fa-circle text-success';
            }
            if (this.payyoWebSocketConnected === false) {
                return 'fa-solid fa-circle text-danger';
            }
            return 'fa-solid fa-spinner fa-spin';
        },

        langKey() {
            if (this.payyoWebSocketConnected === true) {
                return 'PAYYO.WEBSOCKET_CONNECTED';
            }
            if (this.payyoWebSocketConnected === false) {
                return 'PAYYO.WEBSOCKET_DISCONNECTED';
            }
            return 'PAYYO.WEBSOCKET_CONNECTING';
        },
    },
};
</script>
